<template>
  <div class="relative overflow-hidden">
    <div class="main-container py-10 text-center px-4">
      <h2 class="text-[30px] lg:text-[52px] font-merriweather font-[900]">
        Connect with Us Today!
      </h2>
      <p class="text-subTitle text-center my-2 font-roboto">
        Reach Out to Our Team of <b>Insurance Experts</b>
      </p>
    </div>
  </div>
  <div class="my-14 px-4">
    <div class="max-w-[1440px] m-auto">
      <div class="flex flex-wrap">
        <div class="w-full md:w-3/6 text-center md:border-r-2 border-[#525355] relative">
          <div class="w-[45%] h-[175px] m-auto">
            <img class="w-auto h-full m-autos" :src="device1Image" alt="" />
          </div>
          <h1 class="my-7 text-[#525355] lg:text-[35px] text-[25px] font-[900] font-merriweather">
            Customer Service
          </h1>
          <p class="text-subTitle text-center my-5 font-roboto lg:max-w-[50%] max-w-[80%] m-auto">
            Get policy info and personalized help at our service portal.
          </p>
          <div>
            <a href="/customerservice" class="btn-shadow inline-block font-roboto text-sm p-5 bg-[#E12F2F] rounded text-white drop-shadow-[-1px_7px_10px_0px_rgb(209,2,2,50)] hover:bg-[#C00202] transition-all duration-500 hover:scale-90">
              <div class="flex items-center text-[16px]">
                <img class="w-[30px] mr-2" :src="appointmentImage" alt="" />
                Customer Service
              </div>
            </a>
          </div>
          <div class="hidden md:flex absolute top-[50%] translate-y-[-50%] lg:right-[-40px] right-[-25px] lg:h-[80px] h-[50px] lg:w-[80px] w-[50px] rounded-full bg-[#525355] lg:text-[35px] text-[25px] text-white font-merriweather items-center justify-center font-[900]">
            OR
          </div>
        </div>
        <div class="md:mt-0 mt-10 w-full md:w-3/6 text-center md:border-l-2 border-[#525355]">
          <div class="w-[45%] h-[175px] m-auto">
            <img class="w-auto h-full m-auto" :src="device2Image" alt="" />
          </div>
          <h1 class="my-7 text-[#525355] lg:text-[35px] text-[25px] font-[900] font-merriweather">
            Call an Agent
          </h1>
          <p class="text-subTitle text-center my-5 font-roboto lg:max-w-[50%] max-w-[80%] m-auto">
            Give us a call and speak to one of our Licensed Insurance Agents
          </p>
          <div>
            <a href="tel:+18002689137" class="btn-shadow inline-block font-roboto text-sm p-5 bg-[#E12F2F] rounded text-white drop-shadow-[-1px_7px_10px_0px_rgb(209,2,2,50)] hover:bg-[#C00202] transition-all duration-500 hover:scale-90">
              <div class="flex items-center text-[16px]">
                <img class="w-[30px] mr-2" :src="callImage" alt="" />
                +1 (800) 268-9137
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import device1Image from '@assets/images/device-1.png';
import device2Image from '@assets/images/device-2.png';
import appointmentImage from '@assets/images/appointment.svg';
import callImage from '@assets/images/call.svg';

export default {
  data() {
    return {
      device1Image,
      device2Image,
      appointmentImage,
      callImage
    };
  },
  mounted() {
    document.body.classList.add('background-overlay');
  },
  beforeUnmount() {
    document.body.classList.remove('background-overlay');
  },
};
</script>

<style scoped>
.background-overlay {
  background-color: transparent;
  background-image: linear-gradient(180deg, #ceced8 0%, #e6e6e6 100%);
  opacity: 0.35;
}
</style>
